import { render, staticRenderFns } from "./OverridingAgtList.vue?vue&type=template&id=6656aaae&"
import script from "./OverridingAgtList.vue?vue&type=script&lang=js&"
export * from "./OverridingAgtList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports